import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import Gps from '@/assets/icons_new/imports/Gps.svg'
import Absences from '@/assets/icons_new/imports/Absences.svg'
import ReadFromActivity from '@/assets/icons_new/imports/ReadFromActivity.svg'
import ScanManulCard from '@/assets/icons_new/imports/ScanManualCard.svg'
import Drivers from '@/assets/icons_new/imports/Drivers.svg'
import FromDelegation from '@/assets/icons_new/imports/FromDelegation.svg'
import FromManulCard from '@/assets/icons_new/imports/FromManulCard.svg'
import FromReader from '@/assets/icons_new/imports/FromReader.svg'
import FromTrimbleActivity from '@/assets/icons_new/imports/FromTrimbleActivity.svg'
import FromTrimbleBorders from '@/assets/icons_new/imports/FromTrimbleBorders.svg'
import WebfleetBorders from '@/assets/icons_nucleo/icons/import/granice_tomtom.svg'
import FromFile from '@/assets/icons_new/imports/FromFile.svg'
import Tms from '@/assets/icons_new/imports/Tms.svg'

import { ImportSource } from '../../enums'
import { faArrowDownToSquare, faFileArrowDown } from '@fortawesome/pro-light-svg-icons'

export type CardConfig = {
  name: ImportSource
  slug: string
  icon: IconDefinition
  faIcon?: IconDefinition
  titleKey: string
  descriptionKey: string
  url: string
}

type ImportsHoceCardsConfig = {
  cards: CardConfig[]
}

export const importsHomeCardsConfig: ImportsHoceCardsConfig = {
  cards: [
    {
      name: ImportSource.File,
      slug: 'wczytaj-z-pliku',
      icon: FromFile,
      faIcon: faArrowDownToSquare,
      titleKey: 'importModule.card-file-title',
      descriptionKey: 'importModule.card-file-desc',
      url: '/imports/wczytaj-z-pliku',
    },
    {
      name: ImportSource.DriverCard,
      slug: 'wczytaj-z-karty',
      icon: FromReader,
      titleKey: 'importModule.card-driver-card-title',
      descriptionKey: 'importModule.card-driver-card-desc',
      url: '/imports/wczytaj-z-karty',
    },
    {
      name: ImportSource.TachographDiscs,
      slug: 'wczytaj-z-tarczki',
      icon: FromManulCard,
      titleKey: 'importModule.card-tachograph-discs-title',
      descriptionKey: 'importModule.card-tachograph-discs-desc',
      url: '/imports/wczytaj-z-tarczki',
    },
    {
      name: ImportSource.ScanDiscs,
      slug: 'skanuj-tarczki',
      icon: ScanManulCard,
      titleKey: 'importModule.card-scan-discs-title',
      descriptionKey: 'importModule.card-scan-discs-desc',
      url: '/imports/skanuj-tarczki',
    },
    {
      name: ImportSource.Gps,
      slug: 'wczytaj-dane-gps',
      icon: Gps,
      titleKey: 'importModule.card-gps-title',
      descriptionKey: 'importModule.card-gps-desc',
      url: '/imports/wczytaj-dane-gps',
    },
    {
      name: ImportSource.Tms,
      slug: 'wczytaj-dane-tms',
      icon: Tms,
      titleKey: 'importModule.card-tms-title',
      descriptionKey: 'importModule.card-tms-desc',
      url: '/imports/wczytaj-dane-tms',
    },
    {
      name: ImportSource.ActivityFile,
      slug: 'odczyt-danych-aktywnosci-z-pliku',
      icon: ReadFromActivity,
      faIcon: faFileArrowDown,
      titleKey: 'importModule.card-activity-file-title',
      descriptionKey: 'importModule.card-activity-file-desc',
      url: '/imports/odczyt-danych-aktywnosci-z-pliku',
    },
    {
      name: ImportSource.Delegations,
      slug: 'wczytaj-delegacje',
      icon: FromDelegation,
      titleKey: 'importModule.card-delegations-title',
      descriptionKey: 'importModule.card-delegations-desc',
      url: '/imports/wczytaj-delegacje',
    },
    {
      name: ImportSource.Absences,
      slug: 'wczytaj-nieobecnosci',
      icon: Absences,
      titleKey: 'importModule.card-absences-title',
      descriptionKey: 'importModule.card-absences-desc',
      url: '/imports/wczytaj-nieobecnosci',
    },
    {
      name: ImportSource.Drivers,
      slug: 'wczytaj-kierowcow',
      icon: Drivers,
      titleKey: 'importModule.card-drivers-title',
      descriptionKey: 'importModule.card-drivers-desc',
      url: '/imports/wczytaj-kierowcow',
    },
    {
      name: ImportSource.BorderCrossings,
      slug: 'wczytaj-dane-o-przekroczeniu-granic',
      icon: FromTrimbleBorders,
      titleKey: 'importModule.card-border-crossings-title',
      descriptionKey: 'importModule.card-border-crossings-desc',
      url: '/imports/wczytaj-dane-o-przekroczeniu-granic',
    },
    {
      name: ImportSource.WebfleetBorders,
      slug: 'wczytaj-granice-webfleet',
      icon: WebfleetBorders,
      titleKey: 'importModule.card-webfleet-borders-title',
      descriptionKey: 'importModule.card-webfleet-borders-desc',
      url: '/imports/wczytaj-granice-webfleet',
    },
    {
      name: ImportSource.ActivityService,
      slug: 'wczytaj-dane-o-aktywnosciach',
      icon: FromTrimbleActivity,
      titleKey: 'importModule.card-activity-service-title',
      descriptionKey: 'importModule.card-activity-service-desc',
      url: '/imports/wczytaj-dane-o-aktywnosciach',
    },
  ],
}

export const MOCK_UPLOAD = false
